module.exports = __webpack_public_path__ + "static/media/caf.7cf4a5f8.svg";